import ProgressBarModifyReturnContainer from './ProgressBarContainer';

const ProgressBarModifyReturn = ProgressBarModifyReturnContainer;

export default ProgressBarModifyReturn;
